import { render } from "./TabA.vue?vue&type=template&id=b832b670&scoped=true"
import script from "./TabA.vue?vue&type=script&lang=js"
export * from "./TabA.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b832b670"

export default script